import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getEnvMessagesStats, clearEnvStats } from 'actions/superuser';
import { HorizontalBar } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import 'chartjs-plugin-colorschemes';

import './StatsAccPerEnv.css';
import { DateTimePicker } from 'elements';
import { transformEnvStats } from '../../utils/stat_utils';

function mapState(state) {
  return {
    ...state.superuser
  };
}

function mapDispatch(dispatch, props) {
  return {
    clearEnvStats() {
      return clearEnvStats(dispatch);
    },
    getEnvMessagesStats(data) {
      return getEnvMessagesStats(dispatch, data);
    }
  };
}

export const envChartPageType = {
  messagesRevenue: 'messagesRevenue'
};

class StatsAccPerEnv extends Component {

  state = {
    dateStart: null,
    dateEnd: null
  };

  static propTypes = {
    pt: PropTypes.string,
    envStats: PropTypes.object,
    clearEnvStats: PropTypes.func,
    getEnvMessagesStats: PropTypes.func
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.pt !== nextProps.pt) {
      this.props.clearEnvStats();
      this.setState({ dateStart: null, dateEnd: null });
    }
  }

  componentWillUnmount() {
    this.props.clearEnvStats();
  }

  handleDateRangeChange(dateStart, dateEnd) {
    this.setState({ dateEnd, dateStart });
    this.handleStatChange(dateStart, dateEnd);
  }

  handleStatChange(dateStart, dateEnd) {
    if (dateStart && dateEnd) {
      const data = {
        dateEnd: dateEnd.format(),
        dateStart: dateStart.format('YYYY-MM-DD HH:mm:ss')
      };
      this.props.clearEnvStats();
      this.props.getEnvMessagesStats(data);
    }
  }

  get selectDateRange() {
    const { dateStart, dateEnd } = this.state;
    return <DateTimePicker
      value={ [dateStart, dateEnd] }
      exportData={ (a, b) => this.handleDateRangeChange(a, b) }
    />;
  }

  get chartHeight() {
    return 200;
  }

  get pageTitle() {
    switch (this.props.pt) {
      case envChartPageType.messagesRevenue:
      default:
        return 'Sales data';
    }
  }

  get charts() {
    const { envStats, pt } = this.props;
    const stats = transformEnvStats(envStats);
    const rawEnvs = Object.keys(stats);
    const envs = rawEnvs.sort();

    const freeMessagesData = {
      datasets: envs.map(i => ({
        data: [stats[i].nFree],
        label: i
      })),
      labels: ['data']
    };

    const paidMessagesData = {
      datasets: envs.map(i => ({
        data: [stats[i].nPaid],
        label: i
      })),
      labels: ['data']
    };

    const revenueData = {
      datasets: envs.map(i => ({
        data: [stats[i].revenue / 100.],
        label: i
      })),
      labels: ['data']
    };

    if (envs.length <= 1) return [];
    switch (pt) { // page type
      case envChartPageType.messagesRevenue:
        return [[freeMessagesData, 'Free Messages'],
          [paidMessagesData, 'Paid Messages'],
          [revenueData, 'Revenue']
        ];
    }
  }

  render() {
    const { dateStart, dateEnd } = this.state;

    return (
      <div className="stat-container">
        <div className="page-title">{ this.pageTitle }</div>
        { this.selectDateRange }
        { (dateStart && dateEnd) &&
        <div className="env-stats">
          <div>
            from: { dateStart.format('YYYY/MM/DD HH:mm:ss') }
          </div>
          <div>
            to: { dateEnd.format('YYYY/MM/DD HH:mm:ss') }
          </div>
        </div>
        }
        { this.charts
          .map((v, i) => (
            <div key={ i }>
              <HorizontalBar
                data={ v[0] }
                height={ this.chartHeight }
                options={ {
                  maintainAspectRatio: false,
                  plugins: {
                    colorschemes: {
                      scheme: 'tableau.Classic20'
                    }
                  },
                  legend: {
                    display: true,
                    position: 'left',
                    align: 'start'
                  },
                  title: {
                    display: true,
                    text: v[1]
                  },
                  scales: {
                    xAxes: [{
                      ticks: {
                        beginAtZero: true
                      }
                    }]
                  }
                } }
              />
            </div>))
        }
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(StatsAccPerEnv));



// WEBPACK FOOTER //
// ./src/pages/stats_acc_per_env/StatsAccPerEnv.jsx